const getUpdateDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const day = date.getUTCDate();
    const month = date.toLocaleString('en', { month: 'long' });
    return `Updated on ${month} ${day}, ${year}`;
};

export { getUpdateDate };
